import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import api from "../services/api";

const MasterLayout = ({ children }) => {
  const [sidebarActive, setSidebarActive] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();
  const [activeDropdown, setActiveDropdown] = useState(null);

  // Inline dropdown toggle handlers
  const toggleDropdown = (dropdownId) => {
    setActiveDropdown(activeDropdown === dropdownId ? null : dropdownId);
  };

  const sidebarControl = () => {
    setSidebarActive(!sidebarActive);
  };

  const mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = async () => {
    try {
      await api.post('/auth/logout');
      localStorage.removeItem("user");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error.response?.data || error.message);
      localStorage.removeItem("user");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      navigate("/");
    }
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay"}>
      <aside
        className={
          sidebarActive
            ? "sidebar active"
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
      >
        <button onClick={mobileMenuControl} type="button" className="sidebar-close-btn">
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link to="/" className="sidebar-logo">
            <img src="assets/images/brokerz.png" alt="site logo" className="light-logo" />
            <img src="assets/images/brokerz.png" alt="site logo" className="dark-logo" />
            <img src="assets/images/brokerz.png" alt="site logo" className="logo-icon" />
            {/* <h5>Brokerz</h5> */}
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu" id="sidebar-menu">
            <li className="sidebar-menu-group-title">Brokerz</li>
            <li>
              <NavLink to="/" className={(navData) => (navData.isActive ? "active-page" : "")}>
                <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
                <span>Dashboard</span>
              </NavLink>
            </li>


            <li
              className={`dropdown ${activeDropdown === "requestsDropdown" ? "open" : ""}`}
              id="requestsDropdown"
            >
              <Link to="#" onClick={() => toggleDropdown("requestsDropdown")}>
                <Icon icon="mage:dashboard" className="menu-icon" />
                <span>Requests</span>
              </Link>
              <ul className="sidebar-submenu">
                <li>
                  <NavLink
                    to="/cils"
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <span>CILs</span>
                  </NavLink>
                </li>
                {user?.type === "admin" && (
                  <li>
                    <NavLink
                      to="/custom-cils"
                      className={(navData) => (navData.isActive ? "active-page" : "")}
                    >
                      <span>Custom CILs</span>
                    </NavLink>
                  </li>
                )}
                <li>
                  <NavLink
                    to="/eois"
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <span>EOIs</span>
                  </NavLink>
                </li>
              </ul>
            </li>
            {user?.type === "admin" && (
              <li>
                <NavLink to="/devs" className={(navData) => (navData.isActive ? "active-page" : "")}>
                  <Icon icon="mage:building-tree" className="menu-icon" />
                  <span>Developers</span>
                </NavLink>
              </li>
            )}
            {user?.type === "admin" && (
              <li
                className={`dropdown ${activeDropdown === "usersDropdown" ? "open" : ""}`}
                id="usersDropdown"
              >
                <Link to="#" onClick={() => toggleDropdown("usersDropdown")}>
                  <Icon icon="mage:users" className="menu-icon" />
                  <span>Users</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li>
                    <NavLink to="/brokers" className={(navData) => (navData.isActive ? "active-page" : "")}>
                      <span>Brokers</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/developersales"
                      className={(navData) => (navData.isActive ? "active-page" : "")}
                    >
                      <span>Developer Sales</span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
            <li>
              <NavLink to="/projects" className={(navData) => (navData.isActive ? "active-page" : "")}>
                <Icon icon="mage:building-tree" className="menu-icon" />
                <span>Projects</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/units" className={(navData) => (navData.isActive ? "active-page" : "")}>
                <Icon icon="mage:home" className="menu-icon" />
                <span>Units</span>
              </NavLink>
            </li>
            {user?.type === "developerSales" && (
              <li>
                <NavLink to="/paymentplans" className={(navData) => (navData.isActive ? "active-page" : "")}>
                  <Icon icon="mage:calendar" className="menu-icon" />
                  <span>Payment Plans</span>
                </NavLink>
              </li>
            )}
            {user?.type === "admin" && (
              <li>
                <NavLink to="/locations" className={(navData) => (navData.isActive ? "active-page" : "")}>
                  <Icon icon="mage:calendar" className="menu-icon" />
                  <span>Locations</span>
                </NavLink>
              </li>
            )}
            {user?.type === "admin" && (
              <li>
                <NavLink to="/approvalRequests" className={(navData) => (navData.isActive ? "active-page" : "")}>
                  <Icon icon="mage:calendar" className="menu-icon" />
                  <span>Approval Requests</span>
                </NavLink>
              </li>
            )}
            {user?.type === "admin" && (
              <li
                className={`dropdown ${activeDropdown === "resaleDropdown" ? "open" : ""}`}
                id="resaleDropdown"
              >
                <Link to="#" onClick={() => toggleDropdown("resaleDropdown")}>
                  <Icon icon="mage:home-percent" className="menu-icon" />
                  <span>Resale</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li>
                    <NavLink
                      to="/resale-units"
                      className={(navData) => (navData.isActive ? "active-page" : "")}
                    >
                      <span>Resale Units</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/resale-interests"
                      className={(navData) => (navData.isActive ? "active-page" : "")}
                    >
                      <span>Resale Interests</span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
            {user?.type === "admin" && (
              <li>
                <NavLink to="/deletionRequests" className={(navData) => (navData.isActive ? "active-page" : "")}>
                  <Icon icon="mage:calendar" className="menu-icon" />
                  <span>Deletion Requests</span>
                </NavLink>
              </li>
            )}
            {user?.type === "admin" && (
              <li>
                <NavLink to="/collectionRequests" className={(navData) => (navData.isActive ? "active-page" : "")}>
                  <Icon icon="mage:calendar" className="menu-icon" />
                  <span>Collection Requests</span>
                </NavLink>
              </li>
            )}
            {user?.type === "admin" && (
              <li>
                <NavLink to="/broker-wallets" className={(navData) => (navData.isActive ? "active-page" : "")}>
                  <Icon icon="mdi:wallet-outline" className="menu-icon" />
                  <span>Broker Wallets</span>
                </NavLink>
              </li>
            )}
            {user?.type === "admin" && (
  <li>
    <NavLink to="/banners" className={(navData) => (navData.isActive ? "active-page" : "")}>
      <Icon icon="icon-park-outline:ad" className="menu-icon" />
      <span>Banners</span>
    </NavLink>
  </li>
)}
            {user?.type === "admin" && (
              <li>
                <NavLink to="/settings" className={(navData) => (navData.isActive ? "active-page" : "")}>
                  <Icon icon="icon-park-outline:setting-two" className="menu-icon" />
                  <span>Settings</span>
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </aside>

      <main className={sidebarActive ? "dashboard-main active" : "dashboard-main"}>
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button type="button" className="sidebar-toggle" onClick={sidebarControl}>
                  {sidebarActive ? (
                    <Icon icon="iconoir:arrow-right" className="icon text-2xl non-active" />
                  ) : (
                    <Icon icon="heroicons:bars-3-solid" className="icon text-2xl non-active" />
                  )}
                </button>
                <button onClick={mobileMenuControl} type="button" className="sidebar-mobile-toggle">
                  <Icon icon="heroicons:bars-3-solid" className="icon" />
                </button>
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                <ThemeToggleButton />
                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle text-xl"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <Icon icon="solar:user-linear" className="icon text-xl" />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-2">
                          {user?.name || "User Name"}
                        </h6>
                        <span className="text-secondary-light fw-medium text-sm">
                          {user?.type || "Role"}
                        </span>
                      </div>
                      <button type="button" className="hover-text-danger">
                        <Icon icon="radix-icons:cross-1" className="icon text-xl" />
                      </button>
                    </div>
                    <ul className="to-top-list">
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                          to="/profile"
                        >
                          <Icon icon="solar:user-linear" className="icon text-xl" /> My Profile
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                          onClick={handleLogout}
                        >
                          <Icon icon="lucide:power" className="icon text-xl" /> Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="dashboard-main-body">{children}</div>

        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0">© 2025 The Brokerz. All Rights Reserved.</p>
            </div>
            <div className="col-auto"></div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
